import React from 'react';

interface IzakayaHeroProps {
  lang: 'ja' | 'en';
}

export const IzakayaHero: React.FC<IzakayaHeroProps> = ({ lang }) => {
  const content = {
    ja: {
      title: 'Tokyo Local Izakaya Night',
      subtitle: '地元の友人のように、東京の夜を楽しもう',
      tagline: 'Experience Tokyo like a local friend',
      description: '観光ガイドではなく、一緒に楽しむ同行型の居酒屋体験。リラックスした雰囲気で、本当の東京の夜を味わいましょう。',
      cta: 'WhatsAppで予約する'
    },
    en: {
      title: 'Tokyo Local Izakaya Night',
      subtitle: 'Experience Tokyo like a local friend',
      tagline: 'Enjoy Tokyo\'s nightlife with a local companion',
      description: 'Not a tour guide, but a friendly companion. Relax and experience authentic Tokyo nightlife in a casual atmosphere.',
      cta: 'Book via WhatsApp'
    }
  };

  const t = content[lang];

  const handleWhatsAppClick = () => {
    const message = lang === 'ja'
      ? `こんにちは！東京居酒屋ナイトツアーに興味があります🍺

【ご希望日】　　年　　月　　日
【参加人数】　　名
【ご希望エリア】荏原町 / 中延 / 戸越 / 武蔵小山（どれでも可）

初めての参加です。詳細・空き状況を教えていただけますか？`
      : `Hi! I'm interested in booking the Tokyo Local Izakaya Night Tour 🍺

[Preferred Date]: 
[Number of Guests]: 
[Preferred Area]: Ebara-cho / Nakanobu / Togoshi / Musashi-Koyama (any is fine)

It's my first time. Could you share availability and details? Thank you!`;
    const whatsappUrl = `https://wa.me/819092895522?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleScrollToCta = () => {
    const el = document.getElementById('final-cta');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/787176204efcfbdc800c4801ee866074.jpg"
          alt="Tokyo Izakaya Night"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-4xl mx-auto px-6 py-20 text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-amber-500/20 backdrop-blur-sm rounded-full border border-amber-400/30 mb-6">
          <i className="ri-beer-line text-amber-400 text-xl"></i>
          <span className="text-amber-100 text-sm font-medium">{t.tagline}</span>
        </div>

        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          {t.title}
        </h1>

        <p className="text-2xl md:text-3xl text-amber-100 mb-8 font-light">
          {t.subtitle}
        </p>

        <p className="text-lg md:text-xl text-gray-200 mb-12 max-w-2xl mx-auto leading-relaxed">
          {t.description}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={handleWhatsAppClick}
            className="inline-flex items-center gap-3 px-8 py-4 bg-green-500 hover:bg-green-600 text-white text-lg font-semibold rounded-full transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            {t.cta}
          </button>

          <button
            onClick={handleScrollToCta}
            className="inline-flex items-center gap-3 px-8 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white text-lg font-semibold rounded-full border border-white/30 hover:border-white/50 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-calendar-check-line text-xl"></i>
            {lang === 'ja' ? '今すぐ予約' : 'Book Now'}
            <i className="ri-arrow-down-line text-lg animate-bounce"></i>
          </button>
        </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-white text-3xl opacity-70"></i>
        </div>
      </div>
    </section>
  );
};